var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "div",
    {
      staticClass: "modal fade",
      attrs: { id: "ShareQrCodeModal", role: "dialog", tabindex: "-1" },
    },
    [
      _c(
        "div",
        { staticClass: "modal-dialog modal-lg modal-dialog-centered" },
        [
          _c("div", { staticClass: "modal-content" }, [
            _c("div", { staticClass: "p-5" }, [
              _vm._v(
                _vm._s(
                  _vm._f("trans")(
                    "Download the file to your phone using this QR-Code"
                  )
                )
              ),
            ]),
            _vm._v(" "),
            _vm._m(0),
            _vm._v(" "),
            _c("div", { staticClass: "modal-footer" }, [
              _c(
                "button",
                {
                  staticClass: "btn close-btn",
                  on: {
                    click: function ($event) {
                      $event.preventDefault()
                      return _vm.close.apply(null, arguments)
                    },
                  },
                },
                [
                  _c("i", { staticClass: "fa fa-times mr-1" }),
                  _c("strong", [_vm._v(_vm._s(_vm._f("trans")("Cancel")))]),
                ]
              ),
            ]),
          ]),
        ]
      ),
    ]
  )
}
var staticRenderFns = [
  function () {
    var _vm = this,
      _c = _vm._self._c
    return _c(
      "div",
      { staticClass: "w-100 d-flex justify-content-center pb-5" },
      [_c("div", { staticClass: "qr-code" })]
    )
  },
]
render._withStripped = true

export { render, staticRenderFns }